import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $BottomReflowShow } from '~/models/portal/bottom-reflow';
import { ClickPosition } from '~/utils/click-position';
import useReflowClick from '~/utils/use-reflow-click';
import { useActiveToCurrentPage } from '~/utils/active/use-active-to-current-page';
import { $BottomReflowText } from '~/utils/libra/bottom-reflow-text';

import './style.scss';

export const BottomReflow: FC = () => {
  const show = useAtomValue($BottomReflowShow);
  const active = useActiveToCurrentPage();

  const { t } = useTranslation();
  const textKey = useAtomValue($BottomReflowText);

  const text = useMemo(() => {
    if (textKey === 'v1') {
      return t('seo_capsuleUpate_v1');
    }

    if (textKey === 'v2') {
      return t('seo_capsuleUpate_v2');
    }

    return t('seo_landing_pill_cta');
  }, [textKey]);

  const handleClick = useReflowClick(
    {
      clickEvent: (_, bundle) => ({
        ...bundle,
        current_position: ClickPosition.bottom_button,
      }),
      defaultBehavior: () => {
        active(ClickPosition.bottom_button);
      },
    },
    [active],
  );

  useEffect(() => {
    if (show) {
      window.Tea('wap_cta_show', {
        current_position: ClickPosition.bottom_button,
      });
    }
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <div className="bottom-reflow" onClick={handleClick}>
      <p>{text}</p>
    </div>
  );
};
